<script>
import { mapActions } from "vuex";

export default {
  data: function () {
    // "SDG" / "SKA" in the chart's own language, which can differ from the UI language when a report graph is captured
    const sdgPrefix = this.$t('su1Results.resultsPage.graph.sdgPrefix', this.language);
    return {
      maxCount: 10,
      series: [],
      chartOptions: {
        labels: [],
        labels_data: Array.from({ length: 17 }, (_, i) => `${sdgPrefix} ${i + 1}`),
        chart: {
          type: "polarArea",
          toolbar: {
            show: false,
          },
        },
        colors: [
          "#E6243C",
          "#D19F2A",
          "#2D9A47",
          "#C22033",
          "#EF412A",
          "#00ADD8",
          "#FDB714",
          "#8F1838",
          "#F36E24",
          "#E01A83",
          "#F99D25",
          "#CD8B2A",
          "#48773C",
          "#007DBB",
          "#40AE49",
          "#00558A",
          "#1A3668",
        ],
        dataLabels: {
          enabled: true,
          formatter: function (value, { seriesIndex, w }) {
            return (
              w.config.labels_data[seriesIndex] +
              ": " +
              w.config.series[seriesIndex]
            );
          },
        },
        legend: {
          show: true,
          position: "right",
          offsetX: -50,
          fontSize: "12px",
          fontWeight: "bold",
          fontFamily: "Roboto",
          color: "#263238",
        },
        stroke: {
          colors: ["#fff"],
        },
        fill: {
          opacity: 0.95,
        },
        title: {
          text: this.language === 'tr' ? 'SKA Hizalama (SKA Hizalama Anket Sonucu)' : "SDG Alignment (SDG Alignment Survey Result)",
          align: "center",
          style: {
            fontSize: "20px",
            heigth: "100px",
            fontFamily: "Muli', Arial, sans-serif",
          },
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return value.toFixed(1);
            },
          },
          show: true,
          max: this.maxCount,
        },
      },
    };
  },

  created() {
    this.getGlobalForPie();
  },
  props: {
    selectedSurveyID: null,
    language: {
      type: String,
      default: localStorage.getItem('lang') || 'en',
    }
  },
  methods: {
    ...mapActions("results", ["su1Pie"]),
    getGlobalForPie() {
      let params = {
        company_id: this.$user.company_id,
        is_deleted: false,
        su1_survey_id: this.selectedSurveyID,
        language: this.language,
      };
      this.su1Pie(params)
        .then((response) => {
          response.data.globalGoalsSelectionCounts.forEach((item) => {
            this.series.push(item.selectionCount);
            this.chartOptions.labels.push(this.$t('su1Results.resultsPage.graph.sdgPrefix', this.language) + " " + item.globalGoalName);

            this.maxCount = Math.max(...this.series);
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
  },
};
</script>

<template>
  <apex-chart type="polarArea" :options="chartOptions" :series="series" width="100%"></apex-chart>
</template>

<style>
.apexcharts-legend {
  justify-content: center !important;
}
</style>